import { createLogger } from 'shared/services/logger';
import us from '../../defines';
import { roundToDecimals } from '../../lib/utility/helpers';
import { genericMessage } from '../../toolbar';
import { triggerUScopeEvent } from '../../_uScope';
import { translate } from 'shared/services/I18nService';

const $t = translate.scope('uScope.extensions.settings-service.settings-panel');

const logger = createLogger('UScope:extensions:SettingsPanel');

export default function SettingsPanel (uScope, userConfig) {
  const self = this;
  var jPanel;
  var jRoot = $(us.idHashROOT);

  // ............................................ setSliderQuality() local
  // setSliderQuality - This function sets the image quality on the preferences tab.
  self.setSliderQuality = function (quality) {
    var jHandle = $('#' + us.idPREFQUALITYSLIDER).find('.ui-slider-handle');
    jHandle.text(quality);
  };

  // ............................................ show() public
  self.show = function (show) {
    if (!show) {
      jPanel.dialog('close');
      return;
    }
    jPanel.dialog('open');
    // Force the dialog to center on each open; otherwise it occasionally appears at the top of the viewport.
    jPanel.dialog({position: {my: 'center', at: 'center', of: jRoot}});

    // .............................................................report tab
    // insure that the current prefs are displayed
    $('#' + us.idREPORTFIXEDWIDTH).val(String(userConfig.get('reportRegionWidth')));
    $('#' + us.idREPORTFIXEDHEIGHT).val(String(userConfig.get('reportRegionHeight')));

    var reportType = +userConfig.get('reportRegionType');
    $('.' + us.clsREPORTTYPE)[reportType].checked = 'checked'; // check current report type

    // .............................................................image info tab
    var link = '';
    $('#' + us.idLINKTEXTBOX).html(link);
    var imageInfo = _getImageInformation();
    $('#' + us.idTABIMAGEINFO).html(imageInfo);

    // .............................................................preferences tab
    if (us.ENABLETHUMBHOVER) {
      var checked = userConfig.get(us.clsDIVTHUMBHOVER);
      $('#' + us.idTHHOVERCHECKBOX).prop('checked', checked); // check thumbnail enlarge on hover checkbox
    }

    us.viewPrefs = {
      'quality': 75,
      'defQuality': 75
    };
    userConfig.set('imageQuality', us.viewPrefs.quality);

    $('#' + us.idPREFQUALITYSLIDER).slider({
      value: us.viewPrefs.quality,
      step: 5,
      // the slide fn gets range 50 to 100 with these settings
      min: 45,
      max: 105,
      slide: function (event, ui) {
        us.viewPrefs.quality = $(this).slider('value');
        $(ui.handle).text(us.viewPrefs.quality);
      },
      stop: function (event, ui) {
        userConfig.set('imageQuality', us.viewPrefs.quality);
      }
    });
    self.setSliderQuality(userConfig.get('imageQuality')); // set the image quality on the slider handle
  };
  // ............................................ _getImageInformation() local
  // improvement:
  //    - use accessors provided by viewport
  var _getImageInformation = function () {
    var imageInfo = $t('no-image-selected-message');
    if (uScope.isThisImageValid()) {
      var thisImg = uScope.getThisImage();
      var xInfo = thisImg.getXinfoObj();

      imageInfo = `${$t('scanner')}` + thisImg.getScanner() +
                `<br>${$t('file')}` + thisImg.getFileName() +
                `<br>${$t('image-id')}` + thisImg.getImageId() +
                `<br>${$t('image-type')}` + `${$t('capture-type', {type: $t(us.captureNames[thisImg.getCaptureType()].toLowerCase())})}`;
      if (xInfo.isFused) {
        for (var i = 0; i < xInfo.fusedFiles.length; i++) { imageInfo += '<br>&nbsp;&nbsp; ' + $t('member-file') + xInfo.fusedFiles[i]; }
      }

      const dims = thisImg.getImageDims();
      imageInfo += `<br><br>${$t('image-dimensions-pixels')} ${dims.w} x ${dims.h} ` +
                `<br>${$t('tile-dimensions-pixels')} ${xInfo.tileWidth} x ${xInfo.tileHeight} ` +
                `<br>${$t('image-resolution-pixel')} ` + thisImg.getBaseMPP() +
                `<br>${$t('image-magnification')} ` + thisImg.xinfo.get_baseMag() + 'x' +
                `<br>${$t('image-normalization-factor')} ` + roundToDecimals(thisImg.getNormalizationFactor(), 2) +
                `<br>${$t('image-depth')} ` + xInfo.depth +
                `<br>${$t('image-channels')} ` + ((xInfo.isFused) ? xInfo.fusedFiles.length : xInfo.samplPerPix) +
                `<br>${$t('image-bit-depth')} ` + xInfo.bitsPerSampl;

      if (xInfo.acqBitsPerSampl) {
        imageInfo += `<br>${$t('acquisition-bit-depth')} ${xInfo.acqBitsPerSampl}`;
      }
      if (thisImg.getCompressionTypeDescription()) {
        imageInfo += `<br><br>${$t('file-compression-type')} ` + thisImg.getCompressionTypeDescription();
      }
      if (thisImg.getCompQuality()) {
        imageInfo += `<br>${$t('compression-quality')} ` + thisImg.getCompQuality();
      }
      if (thisImg.getImageICCProfile()) {
        imageInfo += `<br>${$t('icc-profile')} ` + thisImg.getImageICCProfile();
      }
      if (thisImg.getScanScopeId()) {
        imageInfo += `<br>${$t('scanner')} ` + thisImg.getScanScopeId();
      }
      if (thisImg.getImageDate()) {
        imageInfo += `&nbsp;&nbsp;${$t('date')} ` + thisImg.getImageDate();
      }

      if (us.ENABLELINKTOIMAGE) { // link to this image
        // format example: http:  //localhost/view.html?fullURL=//aperio-00824:82/@@bYOUR_TOKEN_HERE==/@5&x=9360&y=9371&mag=20
        //                 http:  //localhost/view.html?fullURL=/imageserver/@@bYOUR_TOKEN_HERE==/@2
        var sImgSrc = thisImg.getFullURL() ? thisImg.getFullURL() : (thisImg.getServer() + thisImg.getImageId());
        // send "normal" graphics coords
        var linkValue = 'http://' + window.location.hostname + '/view.html?fullURL=' + sImgSrc +
                    '&x=' + thisImg.getViewCenterX(true) + '&y=' + thisImg.getViewCenterY(true) + '&mag=' + thisImg.getViewMag();
        var imageLinkDOM = $('<div>').prepend('<br>')
          .append($('<button>', {id: us.idCOPYLINKBTN})
            .append($('<span>', {
              id: us.idLINKIMAGE
            }))
            .append($t('copy-image-link')))
          .after('<br>')
          .after($('<div>', {id: us.idLINKTEXTBOX, title: $t('current-image-link')})
            .append(linkValue));
        var imageLink = $('<div>').append(imageLinkDOM.clone()).html(); // convert to string
        imageInfo += imageLink;
      }
    }
    return imageInfo;
  };
    // ............................................ bindEvents_() local
    // bindEvents_ - This function adds the settings panel event handlers.
  var bindEvents_ = function () {
    // bind imageupdate and close this panel if it is open
    jRoot.on(us.evIMAGEUPDATE, function (e, parms) { // always close the options dialog when image changes
      if (jPanel.is(':visible') && jPanel.hasClass('ui-dialog-content')) {
        jPanel.dialog('close');
      }
    });

    // user preference update
    jRoot.on(us.evUSERPREFDEFAULTREPORT + '.report', function (e, parms) {
      userConfig.set('reportRegionWidth', us.eReportSpec.defWidthPx);
      userConfig.set('reportRegionHeight', us.eReportSpec.defHeightPx);
      userConfig.set('reportRegionType', us.eReportSpec.defReportType);
      // update the panel
      $('#' + us.idREPORTFIXEDWIDTH).val(String(userConfig.get('reportRegionWidth')));
      $('#' + us.idREPORTFIXEDHEIGHT).val(String(userConfig.get('reportRegionHeight')));

      var reportType = +userConfig.get('reportRegionType');
      $('.' + us.clsREPORTTYPE)[reportType].checked = 'checked';
    });

    // ............................................ settings panel, pref buttons
    jRoot.on('click', '#' + us.idTHHOVERCHECKBOX, function (e) { // change thumbnail hover pref
      // the checked state into this fn is the changed state
      userConfig.set(us.clsDIVTHUMBHOVER, this.checked);
    });
    jRoot.on('click', '.' + us.clsPREFBUTTON, function (e) {
      var thisImg;
      var target = e.currentTarget.id;
      if (target === us.idPREFLABELROTBTN) {
        thisImg = uScope.getThisImage(); // multi-image - note that all images must be updated here
        if (thisImg) {
          const label = uScope.pluginService.getInstance(uScope.getThisImage(), 'us:label');
          userConfig.set('labelRotation', label.getViewAngle());
        }
      } else if (target === us.idPREFDEFAULTBTN) { // default pref tab
        triggerUScopeEvent(us.evUSERPREFDEFAULTLABELROT, {status: true}); // fire event to default label rotation
        triggerUScopeEvent(us.evUSERPREFDEFAULTTHUMBHOVER, {status: true}); // fire event to default thumbnail hover enlargement
      } else if (target === us.idRPTDEFAULTBTN) { // default report tab
        triggerUScopeEvent(us.evUSERPREFDEFAULTREPORT, {status: true}); // fire event
      }
    });
    // ............................................ settings panel, report tab
    jRoot.on('change', '#' + us.idREPORTFIXEDWIDTH + ',#' + us.idREPORTFIXEDHEIGHT, function (e) {
      var target = e.currentTarget.id;
      var value = +($('#' + target).val());

      // if the value is out of bounds, revert to the prior value and inform the user
      if (value < us.eReportSpec.minDimPx || value > us.eReportSpec.maxDimPx) {
        var dim;
        if (target == us.idREPORTFIXEDWIDTH) {
          $('#' + target).val(String(userConfig.get('reportRegionWidth')));
          dim = 'width';
        } else {
          $('#' + target).val(String(userConfig.get('reportRegionHeight')));
          dim = 'height';
        }
        var msg = $t('fixed-report-region-message', {
          dim: $t(dim),
          minDimPx: us.eReportSpec.minDimPx,
          maxDimPx: us.eReportSpec.maxDimPx
        });
        genericMessage(msg, $t('value-out-of-bounds'));
      } else { // otherwise keep the change and update the prefs
        if (target == us.idREPORTFIXEDWIDTH) { userConfig.set('reportRegionWidth', value); } else { userConfig.set('reportRegionHeight', value); }
      }
    });
    jRoot.on('click', '.' + us.clsREPORTTYPE, function (e) {
      var target = e.currentTarget;
      var value = $(target).val();
      userConfig.set('reportRegionType', value);
    });
  };

    // ............................................ init_() local
    //    init_ - This function creates and intializes the settings panel.
  var init_ = function () {
    if (jPanel != undefined) jPanel.remove();
    jPanel = $('<div/>', {
      'class': us.clsPANEL + ' ' + us.clsPANELCLICKCLOSE,
      'title': $t('options'),
      css: {'overflow-y': 'hidden', 'max-height': 560}
    });

    var reportTab = initReportTab_();
    var prefsTab = initPrefsTab_();
    var imageinfoTab = '<div id=' + us.idIMAGEINFODIV + '>' + '</div>';
    var hotkeysTab = initHotKeysTab_();
    var aboutTab = `${$t('program-version')} ${uScope.getProgVersion()} <br/> ${uScope.getProgDate()}`;

    var tabStr = // make tabs and their panel
            '<div id=' + us.idSETTINGSTABS + '>' + '<ul>';
    tabStr += `<li><a href="#${us.idTABHOTKEYS}">${$t('keyboard-shortcuts')}</a></li>
            <li><a href="#${us.idTABPREFERENCES}">${$t('preferences')}</a></li>
            <li><a href="#${us.idTABREPORT}">${$t('report')}</a></li>
            <li><a href="#${us.idTABIMAGEINFO}">${$t('image')}</a></li>
            <li><a href="#${us.idTABABOUT}">${$t('about')}</a></li>`;
    tabStr += '</ul>';

    tabStr += '<div id=' + us.idTABHOTKEYS + '>' + hotkeysTab + '</div>' +
            '<div id=' + us.idTABPREFERENCES + '>' + prefsTab + '</div>' +
            '<div id=' + us.idTABREPORT + '>' + reportTab + '</div>' +
            '<div id=' + us.idTABIMAGEINFO + '>' + imageinfoTab + '</div>' +
            '<div id=' + us.idTABABOUT + '>' + aboutTab + '</div>';

    tabStr += '</div>';

    var jTabs = $(tabStr); // create the tab jq object
    jPanel.append(jTabs); // add the tabs to the panel

    jPanel.dialog({ // call to create the dialog. Make it modal or the image link can get out of sync with the selected image
      autoOpen: false,
      modal: false,
      draggable: true,
      stack: true,
      resizable: false,
      width: '490px',
      dialogClass: 'uscope-dialog dialogMover',
      appendTo: jRoot,
      closeText: $t('close'),
      position: {my: 'center', at: 'center', of: jRoot},
      open: function (event, ui) {
        $('#' + us.idSETTINGSTABS).tabs({
          heightStyle: 'auto',
          activate: function (event, ui) {
            if (ui.newPanel && ui.newPanel.selector == ('#' + us.idTABIMAGEINFO)) { // call to create the tabs; tab content should fill the height of the dialog for consistency
              var imageLink = ui.newPanel.find('#' + us.idLINKTEXTBOX);
              selectText(imageLink); // select the link URL by default (so it is easy for user to manually copy)
              var copyButton = ui.newPanel.find('#' + us.idCOPYLINKBTN);
              try {
                if (copyButton.length > 0 && document.queryCommandSupported('copy') && document.queryCommandEnabled('copy')) {
                  copyButton.on('click', function () {
                    try {
                      selectText(imageLink); // Select the image link again in case it was de-selected
                      var successful = document.execCommand('copy'); // Execute the copy command if available
                      var msg = successful ? $t('image-link-copied-message') : $t('problem-copying-image-message');
                      alert(msg);
                    } catch (err) {
                      logger.error('cSettingsPanel: init: The copy link command threw an exception.', err);
                    }
                  });
                } else { // Don't bother showing the copy button if the browser won't copy the link...
                  copyButton.remove();
                }
              } catch (err) {
                if ((copyButton).is(':visible')) {
                  copyButton.hide(); // Hide copy link button if not supported
                  imageLink.before(`<p>$t('image-copy-to-clipboard')</p>`);
                }
              }
            }
          }
        });
      }
    });

    bindEvents_(); // add event handlers
  };

    // ............................................ initPrefsTab_() local
    // improvements;
    //        option for magnifier diameter
    //        option for jpeg tile quality
    //        option for autopan speed
  var initPrefsTab_ = function () {
    var labelTTip = $t('use-current-title');

    var prefs =
            `<div><span class="${us.clsSETCHOICE}" title="${labelTTip}">${$t('label-rotation')}<button class="${us.clsPREFBUTTON}" id="${us.idPREFLABELROTBTN}" type="button">${$t('use-current')}</button></span></div>`;

    if (us.ENABLETHUMBHOVER) {
      prefs += `<br><span>${$t('thumbnail-enlarge-on-hover')}&nbsp;&nbsp;&nbsp;&nbsp;</span>`; // thumbnail hover pref
      prefs += '<input id="' + us.idTHHOVERCHECKBOX + '"  type="checkbox" name="us.idTHHOVERCHECKBOX" value="us.idTHHOVERCHECKBOX"/><br>';
    }

    prefs += '<br>';
    return prefs;
  };

    // ............................................ initReportTab_() local
  var initReportTab_ = function () {
    var defaultTTip = $t('default-preferences-tooltip');
    var report =
            '<div id="' + us.idREPORTFIXEDDIV + '">' +
            `<div>&nbsp;&nbsp;&nbsp;${$t('fixed-region-size-pixels', {startBold: '<b>', endBold: '</b>'})}</div>` +
            '<br>&nbsp;&nbsp;' +
            '<span>' + $t('width') + '&nbsp;&nbsp;</span><input id="' + us.idREPORTFIXEDWIDTH + '" type="text" value=' + String(userConfig.get('reportRegionWidth')) + '/>' +
            '&nbsp;&nbsp;&nbsp;&nbsp;' +
            '<span>' + $t('height') + '&nbsp;&nbsp;</span><input id="' + us.idREPORTFIXEDHEIGHT + '" type="text" value=' + String(userConfig.get('reportRegionHeight')) + '/>' +
            '<br></div>' +
            `<br><Input type = radio Name = rptType class ="${us.clsREPORTTYPE}" Value="0" checked> ${$t('full-resolution-image-fixed-sized-report-region')}
             <br><Input type = radio Name = rptType class ="${us.clsREPORTTYPE}" Value="1"> ${$t('full-resolution-image-user-drawn-report-region')}
             <br><Input type = radio Name = rptType class ="${us.clsREPORTTYPE}" Value="2"> ${$t('current-image-resolution-fixed-sized-report-region')}
             <br><Input type = radio Name = rptType class ="${us.clsREPORTTYPE}" Value="3"> ${$t('current-image-resolution-user-drawn-report-region')}` +
            '<br><br>' +
            '<div class="' + us.clsSETCHOICE + '"><span><button class="' +
            us.clsPREFBUTTON + '" Title="' + defaultTTip + '" id="' + us.idRPTDEFAULTBTN + '"  type="button">' + $t('default') + '</button></span><br></div>' +
            '<br>';
    return report;
  };

  // ............................................ initHotKeysTab_() local
  var initHotKeysTab_ = function () {
    // arrow key navigation:    Move the image in view up,down,left,right 1/4 of the view width,height.
    //                            If the shift key is down, Move the image in view up,down,
    //                            left,right 3/4 of the view width,height.
    // control - navigation:    zoom out
    // control + navigation:    zoom in
    //
    // delete:                    delete selected annotation
    // r:                        rotate cw +15 degrees
    // shift r:                    rotate cw +1 degrees
    // control r:                rotate ccw +15 degrees
    // control shift r:            rotate ccw +1 degrees
    // 0, num0:                    set rotation to 0 degrees

    var hotkeys =
            '<div id="' + us.idTABHOTKEYS + '">' +
            '<table><tbody>' +
            `<tr><td colspan="2"><h4>${$t('slide-change')}</h4></td></tr> ` +
            `<tr><td>${$t('previous-keyshortcuts-key')}</button></td><td>${$t('previous-keyshortcuts-text')}</td></tr>` +
            `<tr><td>${$t('next-keyshortcuts-key')}</button></td><td>${$t('next-keyshortcuts-text')}</td></tr>` +

            '<tr><td>&nbsp;</td></tr>' +
            `<tr><td colspan="2"><h4>${$t('view-navigation')}</h4></td></tr> ` +
            `<tr><td>${$t('arrow-keys')}</td><td>${$t('move-view-small', {distance: '1/4'})}</td></tr>` +
            `<tr><td>${$t('shift-arrow-keys')}</td><td>${$t('move-view-large', {distance: '3/4'})}</td></tr>` +

            '<tr><td>&nbsp;</td></tr>' +
            `<tr><td colspan="2"><h4>${$t('view-magnification')}</h4></td></tr> ` +
            `<tr><td>${$t('control', {cmd: '-'})}</td><td>${$t('zoom-out')}</td></tr>` +
            `<tr><td>${$t('control', {cmd: '+'})}</td><td>${$t('zoom-in')}</td></tr>` +
            `<tr><td>${$t('double-click')}</td><td>${$t('toogle-magnifications')}</td></tr>` +

            '<tr><td>&nbsp;</td></tr>' +
            `<tr><td colspan="2"><h4>${$t('view-rotation')}</h4></td></tr> ` +
            `<tr><td>${$t('r-key')}</td><td>${$t('rotate-cw-degrees-text', {angle: '+15'})}</td></tr>` +
            `<tr><td>${$t('shift-R-key')}</td><td>${$t('rotate-cw-degrees-text', {angle: '+1'})}</td></tr>` +
            `<tr><td>${$t('control-r-key')}</td><td>${$t('rotate-ccw-degrees-text', {angle: '+15'})}</td></tr>` +
            `<tr><td>${$t('control-shift-R-key')}</td><td>${$t('rotate-ccw-degrees-text', {angle: '+1'})}</td></tr>` +
            `<tr><td>${$t('zero')}</td><td>${$t('rotation-degrees', {angle: '0'})}</td></tr>` +

            '<tr><td>&nbsp;</td></tr>' +
            `<tr><td colspan="2"><h4>${$t('annotations')}</h4></td></tr> ` +
            `<tr><td>${$t('control-m-key')}</td><td>${$t('toggle-move-pin-selected-annotation')}</td></tr>` +
            `<tr><td>${$t('control-c-key')}</td><td>${$t('copy-selected-annotation')}</td></tr>` +
            `<tr><td>${$t('control-v-key')}</td><td>${$t('paste-copied-selected-annotation')}</td></tr>` +
            `<tr><td>${$t('delete-key')}</td><td>${$t('delete-selected-annotation')}</td></tr>` +

            '</tbody></table>' +
            '</div><br>';
    return hotkeys;
  };
    // ............................................ construction
  init_();
}

const selectText = (element) => {
  if (element.length > 0) {
    element = element[0];
    let range, selection;

    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/settings-services/settings-panel.js